import React from 'react'
import { Spinner } from './Spinner'

export const Button = ({ 
  type = "button", 
  disabled = false, 
  loading = false, 
  children, 
  className = "",
  variant = "primary",
  ...props 
}) => {
  const baseClasses = "w-full py-2.5 px-4 rounded-md font-medium transition duration-200 text-sm flex items-center justify-center"
  
  const variants = {
    primary: `bg-teal-500 text-white hover:bg-teal-600 ${loading || disabled ? "opacity-70 cursor-not-allowed" : ""}`,
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`${baseClasses} ${variants[variant]} ${className}`}
      {...props}
    >
      {loading ? (
        <Spinner size="sm" color="white" withText text="Signing in..." />
      ) : children}
    </button>
  )
}